// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as moment from 'moment';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import {
	ORDER_STATUS,
	VIRTUAL_ORDER,
	ACTIVE_ORDER,
	CANCELLED_ORDER,
	FAILED_ORDER,
	MACHINE_ORDER,
} from '../../constants';

const useStyles = makeStyles((theme) => ({
	header: {
		fontSize: 14,
		fontWeight: 400,
		color: '#333333',
		textAlign: 'center',
		marginBottom: 10,
		lineHeight: '18px',
		paddingTop: '10px',
	},
	heading: {
		margin: 0,
		fontWeight: 'bold',
		fontSize: 16,
		lineHeight: '18px',
		marginBottom: 2,
	},
	toggleOrder: {
		color: 'inherit',
		padding: 0,
		'& .MuiIcon-root': {
			color: 'inherit',
			height: 16,
			fontSize: 20,
			lineHeight: '14px',
		},
	},
	homeIcon: {
		fontSize: '24px',
		height: '30px',
		color: 'white',
		lineHeight: '28px',
		width: 'inherit',
	},
	locationIcon: {
		fontSize: 14,
		verticalAlign: 'top',
		width: 17,
		height: 17,
	},
}));

type Props = {
	orderDetails: any,
	index: number,
	totalOrders: number,
	totalItems: number,
	isExpanded: boolean,
	onToggleExpand: Function,
	cancelledOrderIds: Set<string>,
	showToggleButton: boolean,
	isOrderActive: Function,
};

function OrderHeader({
	orderDetails,
	index,
	totalOrders,
	totalItems,
	isExpanded,
	onToggleExpand,
	cancelledOrderIds,
	showToggleButton,
	isOrderActive,
}: Props) {
	const styles = useStyles();

	console.log('🎯 OrderHeader render:', {
		orderId: orderDetails.order_id,
		status: orderDetails.status,
		cancelledOrderIds: Array.from(cancelledOrderIds),
		isInCancelledIds: cancelledOrderIds.has(orderDetails.order_id)
	});

	// Increment index for display (1-based instead of 0-based)
	const displayIndex = index + 1;

	return (
		<header className={styles.header}>
			<h2 className={styles.heading}>
				{totalOrders > 1 && `${displayIndex}. `}
				{orderDetails.type_of_order === VIRTUAL_ORDER
					? 'Delivery Order'
					: isOrderActive(orderDetails)
						? 'Pickup from Machine'
						: ''
				}
			</h2>
			<div>
				<span>ORDER# {orderDetails.order_id}</span>
				{showToggleButton && (
					<IconButton
						aria-label='toggle view'
						classes={{ root: styles.toggleOrder }}
						onClick={() => onToggleExpand(index)}
					>
						<Icon className={styles.homeIcon}>
							{isExpanded ? `keyboard_arrow_up` : `keyboard_arrow_down`}
						</Icon>
					</IconButton>
				)}
			</div>
			<div>{moment(orderDetails.order_created_at || orderDetails.created_at).format('D MMM YYYY, h:mm a')}</div>
			<Collapse in={isExpanded}>
				{orderDetails.type_of_order === MACHINE_ORDER && (
					<div>
						<LocationOnOutlinedIcon className={styles.locationIcon} />
						<span>{orderDetails.location}</span>
					</div>
				)}
				<div style={{ fontSize: 12 }}>
					{totalItems} units, &#x20b9;
					{orderDetails.type_of_order === MACHINE_ORDER &&
					[ACTIVE_ORDER, CANCELLED_ORDER, FAILED_ORDER].includes(orderDetails.status)
						? orderDetails.pre_auth_amount
						: orderDetails.order_amount}
				</div>
				{(orderDetails.status !== ACTIVE_ORDER || cancelledOrderIds.has(orderDetails.order_id)) && (
					<div
						style={{
							textTransform: 'capitalize',
							fontWeight: 600,
							color: cancelledOrderIds.has(orderDetails.order_id)
								? '#ff6b6b'  // Light red color for cancelling status
								: ORDER_STATUS[orderDetails.status] === FAILED_ORDER ? 'red' : 'inherit',
						}}
					>
						{cancelledOrderIds.has(orderDetails.order_id)
							? 'Cancelling...'
							: ORDER_STATUS[orderDetails.status]
						}
					</div>
				)}
			</Collapse>
		</header>
	);
}

export default OrderHeader;